import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormField from './../FormField';
import CategoryField from './../CategoryField';
import VenueField from './../VenueField';
import { formValues } from 'redux-form';
import allCategories from 'lib/categoriesMapper';
import max from 'lodash/max';
import styles from './PluginFieldset.scss';

const PluginFieldset = formValues({
  required_pricing_tier_level: 'required_pricing_tier_level',
  category_id: 'category_id', sub_categories: 'sub_categories',
  online: 'online'
})(({
  formErrors, categories, config, currentUser, pricingTiers, required_pricing_tier_level,
  category_id, sub_categories, onVenueSelect, online
}) => {
  let maxPricingTier = null;
  const currentCategories = allCategories(category_id, sub_categories, categories);
  const currentPricingTier = max(currentCategories.map((el) => el.pricing_tier_level));
  if (currentUser && !currentUser.isEmpty()) {
    const userPricingTiers = currentUser.get('available_pricing_tiers');
    if (userPricingTiers && !userPricingTiers.isEmpty()) {
      maxPricingTier = userPricingTiers.max();
    }
  }

  if (config.get('premium_edit') && required_pricing_tier_level) {
    maxPricingTier = required_pricing_tier_level;
  }

  const searchOptions = online ? { types: ['(regions)'] } : {};
  const placeholder = online ? 'Search for a city / country' : 'Search for a venue by name or address';

  return (
    <div className="PluginFieldset">
      <div className="row">
        <div className="col-12">
          <FormField
            label="Event Title"
            error={formErrors.get('title')}
            name="title"
            component="input"
            type="text"
            className="form-control"
            placeholder="e.g. My interesting event..."
            maxLength={100}
            normalize={val => val.substr(0, 100)}
            required
            clearMargin={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <FormField
            name="category_id"
            label="Category"
            error={formErrors.get('category_id')}
            component={CategoryField}
            inputProps={{ valueField: 'id', textField: 'name_with_path', clearable: true, allowModalPreopening: true }}
            config={config}
            placeholder="Start typing to search..."
            categories={categories}
            maxPricingTier={maxPricingTier}
            currentPricingTier={currentPricingTier}
            pricingTiers={pricingTiers}
            required
            type="text"
            className="form-control"
            algolia-autocomplete
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormField
            label="Virtual Event"
            name="online"
            component="input"
            type="checkbox"
            inputProps={ { className: styles.onlineCheck } }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <FormField
            name="venue"
            label="Venue / Location"
            error={formErrors.get('venue')}
            component={VenueField}
            inputProps={{ onVenueSelect, searchOptions, placeholder }}
            config={config}
            required={!online}
            className="form-control"
          />
        </div>
      </div>
    </div>
  );
});

PluginFieldset.propTypes = {
  formErrors: PropTypes.object,
  categories: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,
  currentUser: ImmutablePropTypes.map,
  pricingTiers: ImmutablePropTypes.map.isRequired,
  category_id: PropTypes.number,
  sub_categories: PropTypes.object,
  onVenueSelect: PropTypes.func.isRequired,
};

export default PluginFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/PluginFieldset.jsx